import React, { useEffect } from 'react';

export default function Redirect(link) {
    useEffect(() => {
        window.location.href = 'http://qrbio.com.br'
    }, [])

    return (<></>)
} 